'use strict';
var ute;
(function (ute) {
    var ui;
    (function (ui) {
        var UteTooltip = (function () {
            /* @ngInject */
            function UteTooltip($timeout, $compile, $http, $templateCache) {
                var _this = this;
                this.$timeout = $timeout;
                this.$compile = $compile;
                this.$http = $http;
                this.$templateCache = $templateCache;
                //endregion
                //region Private
                /**
                 * Parses string to boolean. Returns false if str is falsy or equals 'false'. Otherwise returns true.
                 * @param str {string}: value to parse
                 * @param defaultVal {boolean}: this value is returned if str is null; default is false
                 * @returns {boolean}
                 */
                this.getBool = function (str, defaultVal) {
                    if (defaultVal == null) {
                        defaultVal = false;
                    }
                    if (str == null) {
                        return defaultVal;
                    }
                    return !!str && str !== 'false' && str !== 'undefined';
                };
                this.getOptions = function (el, scope) {
                    return {
                        position: {
                            my: scope.ttMy || 'top center',
                            at: scope.ttAt || 'bottom center',
                            target: scope.ttTarget ? $(scope.ttTarget) : el,
                            adjust: {
                                method: scope.ttAdjustMethod || 'shift',
                                x: (scope.ttAdjustX ? parseInt(scope.ttAdjustX.toString(), 10) : 0),
                                y: (scope.ttAdjustY ? parseInt(scope.ttAdjustY.toString(), 10) : 0)
                            }
                        },
                        show: {
                            effect: _this.getBool(scope.ttShowEffect, true),
                            event: scope.ttEvent || 'mouseover',
                        },
                        hide: {
                            effect: _this.getBool(scope.ttHideEffect, true),
                            fixed: _this.getBool(scope.ttFixed, true),
                            delay: (scope.ttDelay == null ? 100 : parseInt(scope.ttDelay.toString(), 10)),
                            event: scope.ttEventOut || 'mouseout'
                        },
                        style: {
                            classes: scope.ttClass || 'qtip',
                            //modal: scope.ttModalStyle || {}, //TBD // Set inline style for the tooltip. This should be a JS object that contains the JS-esque style properties (such as `maxHeight: '100vh'`) | object | {} |
                            tip: scope.ttTipStyle || {}
                        }
                    };
                };
                this.generateQtip = function (content, scope, el, attrs) {
                    var options = _this.getOptions(el, scope);
                    var isDynamic = _this.getBool(scope.ttDynamic, false);
                    var isPopup = _this.getBool(scope.ttPopup, false);
                    var isModal = _this.getBool(scope.ttModal, false);
                    var jQueryElement = $(el);
                    if (scope.ttHide != null) {
                        options.hide = scope.ttHide;
                    }
                    if (scope.ttShow != null) {
                        options.show = scope.ttShow;
                    }
                    if (isModal) {
                        if (options.show == null) {
                            options.show = {};
                        }
                        var showObj = options.show;
                        if (showObj != null && showObj.modal == null) {
                            showObj.modal = {
                                on: true,
                                blur: false,
                                escape: true,
                                stealfocus: false,
                                effect: false
                            };
                            isPopup = true; // Modal enforces popup
                        }
                        else {
                            console.error("ttModal=true setting is incompatible with options.show=" + JSON.stringify(options.show));
                        }
                    }
                    if (scope.ttOptions != null) {
                        options = angular.extend({}, options, scope.ttOptions);
                    }
                    if (!options.content) {
                        options.content = content != null ? content : {
                            text: scope.ttContent || scope.uteTooltip
                        };
                    }
                    if (isPopup) {
                        var cnt = options.content;
                        if (cnt != null) {
                            cnt.button = true;
                            (options.show).event = 'click';
                            (options.hide).event = false;
                        }
                    }
                    // initialize qtip on the element
                    jQueryElement.qtip(options);
                    // add watchers for all dynamic parameters (to be extended):
                    _this.addWatch(scope, function (scope) { return scope.ttVisible; }, function (newVal) {
                        jQueryElement.qtip('toggle', newVal);
                    });
                    _this.addWatch(scope, function (scope) { return scope.ttDisabled; }, function (newVal) {
                        jQueryElement.qtip('disable', newVal);
                    });
                    if (isDynamic) {
                        _this.addWatch(scope, function (scope) { return scope.ttTitle; }, function (newVal) {
                            jQueryElement.qtip('option', 'content.title', newVal);
                        });
                        _this.addWatch(scope, function (scope) { return scope.ttContent; }, function (newVal) {
                            jQueryElement.qtip('option', 'content.text', newVal);
                        });
                    }
                  return jQueryElement;
                };
                //endregion
                //region Public
                this.restrict = 'A';
                this.scope = {
                    uteTooltip: '@',
                    ttContent: '=?',
                    ttTitle: '=?',
                    ttTarget: '@',
                    ttSelector: '@',
                    ttTemplate: '@',
                    ttTemplateVm: '=?',
                    ttVisible: '=?',
                    ttDisabled: '=?',
                    ttFixed: '=?',
                    ttDynamic: '=?',
                    ttPopup: '=?',
                    ttModal: '=?',
                    ttPersistent: '=?',
                    ttDelay: '@',
                    ttAdjustX: '@',
                    ttAdjustY: '@',
                    //ttModalStyle: '=?', // do not remove
                    ttTipStyle: '=?',
                    ttShowEffect: '=?',
                    ttHideEffect: '=?',
                    ttEvent: '@',
                    ttEventOut: '@',
                    ttHide: '=?',
                    ttShow: '=?',
                    ttClass: '@',
                    ttMy: '@',
                    ttAt: '@',
                    ttAdjustMethod: '@',
                    ttOptions: '=?'
                };
                this.link = function (scope, el, attrs) {
                    // Need this trick to overcome TS limitation: Only public and protected methods of the base class are accessible via the 'super' keyword
                    _this.doLink(scope, el, attrs);
                };
                this.doLink = function (scope, el, attrs) {
                    var content = {};
                    //let text: QTip2.Text;
                    // Title specified, add it
                    if (scope.ttTitle != null) {
                        content.title = scope.ttTitle;
                    }
                    // Get HTML from the DOM element by CSS selector
                    if (scope.ttSelector) {
                        content.text = ($(scope.ttSelector)).html();
                        _this.generateQtip(content, scope, el, attrs);
                        return;
                    }
                    if (scope.ttTemplate != null) {
                        _this.$http.get(scope.ttTemplate, {
                            cache: _this.$templateCache
                        }).then(function (response) {
                            _this.$timeout(function () {
                                content.text = function () {
                                    return scope.$apply(function () {
                                        var text = _this.$compile(response.data)(scope.ttTemplateVm || scope);
                                        return text;
                                    });
                                };
                                _this.generateQtip(content, scope, el, attrs);
                            });
                        });
                        return;
                    }
                    // ttContent or useTooltip is a string:
                    var contentVal = (scope.uteTooltip || scope.ttContent);
                    if (!contentVal && scope.ttOptions != null && scope.ttOptions.content != null) {
                        contentVal = scope.ttOptions.content.text;
                    }
                    var contentPromise = null;
                    if ($.isFunction(contentVal)) {
                        // it's a function returning promise
                        contentPromise = contentVal();
                    }
                    else if (!!contentVal.then) {
                        // it's a promise
                        contentPromise = contentVal;
                    }
                    else if (typeof contentVal !== 'string') {
                        throw Error("Unsupported content type: " + JSON.stringify(contentVal) + ". Expecting string, string function, or string promise");
                    }
                    if (contentPromise == null) {
                        // plain text, generate the tooltip immediately
                        content.text = contentVal;
                        _this.generateQtip(content, scope, el, attrs);
                    }
                    else {
                        // promise, deferred tooltip generation
                        contentPromise.then(function (result) {
                            content.text = !result.data ? result : result.data;
                            var qtipElement = _this.generateQtip(content, scope, el, attrs);
                            setTimeout(function() {
                              qtipElement.qtip('toggle', true);
                            }, 1);
                        }).catch(function (error) {
                            console.error(error); // do not throw exception if async call fails, just log the error
                        });
                    }
                };
            }
            /* @ngInject */
            UteTooltip.instance = function ($timeout, $compile, $http, $templateCache) {
                return new UteTooltip($timeout, $compile, $http, $templateCache);
            };
            UteTooltip.prototype.addWatch = function (scope, attrGetter, onValueChange) {
                var val = attrGetter(scope);
                if (val == null) {
                    return; // not specified, do nothing
                }
                scope.$watch(attrGetter, function (newVal) {
                    try {
                        return onValueChange(newVal);
                    }
                    catch (e) {
                        console.error(e); // log and ignore any errors
                    }
                });
            };
            ;
            //region Static & Constructor
            UteTooltip.$inject = ['$timeout', '$compile', '$http', '$templateCache'];
            return UteTooltip;
        }());
        ui.UteTooltip = UteTooltip;
        angular.module('ute.ui').directive('uteTooltip', ['$timeout', '$compile', '$http', '$templateCache', UteTooltip.instance]);
    })(ui = ute.ui || (ute.ui = {}));
})(ute || (ute = {}));

